/**
 * 这里的 id 不能随便改，接口可能会返回这些 id
 */

// 咨询礼
export const PRODUCT_CONSULT_GIFT = 32
// 平台活动
export const PRODUCT_PLATFORM_ACTIVITY = 40
// 旗舰版
export const PRODUCT_PRO = 50
// 小程序
export const PRODUCT_WECHAT_WEAPP = 65
// 套餐热标
export const PRODUCT_MEAL_HOT_TAG = 70
// 订单可退
export const PRODUCT_ORDER_REFUND = 71
// 商家承诺
export const PRODUCT_MERCHANT_PROMISE = 72
// 到店礼
export const PRODUCT_ARRIVE_GIFT = 73
// 多店管理
export const PRODUCT_MULTI_STORE = 74
// 推荐橱窗
export const PRODUCT_RECOMMEND_WINDOW = 75
// 主题模版
export const PRODUCT_THEME_TEMPLATE = 76
// 微官网
export const PRODUCT_MICRO_WEBSITE = 77
// 婚礼现场
export const PRODUCT_WEDDING_HALL = 78
// 轻松聊
export const PRODUCT_EASY_CHAT = 80
// 天眼系统
export const PRODUCT_SKY_EYE = 81
// 优惠券
export const PRODUCT_COUPONS = 82
// 微传单+
export const PRODUCT_REGISTRATION_ACTIVITY = 90
// 标准版
export const PRODUCT_STANDARD = 197
// 标准版升级旗舰版
export const PRODUCT_STANDARD_PRO = 198
// 尊享版
export const PRODUCT_ZUNXIANG = 295

// TODO（以下暂定）
export const PRODUCT_WATER_MIRROR = 900 // 水镜
export const PRODUCT_JUKE = 902 // 聚客宝
export const PRODUCT_LIVE = 903 // 直播
export const PRODUCT_ZHI_GUANG_TONG = 904 // 智优投
export const PRODUCT_ZHI_TUI_BAO = 905 // 智推宝
export const PRODUCT_MULTI_SERVICE = 906 // 多客服系统
export const PRODUCT_SMART_RECEPTION = 907 // 预设问题
export const PRODUCT_HAI_CAO_YUN = 908 // 海草云
export const PRODUCT_INVITATION_CARD = 909 // 请帖
export const PRODUCT_SHOP_DATA = 910 // 店铺数据
export const PRODUCT_NAME_CARD = 911 // 海草名片
export const PRODUCT_SERVICE_FEE = 912 // 服务费账户充值
export const PRODUCT_VR = 913 // VR
export const PRODUCT_MV_CARD = 914 // VR

//特色信息、专享优惠酒店特有
export const PRODUCT_UNIQUE_INFO = 992 // 特色信息
export const PRODUCT_ZHUANXIANG = 991 // 专享优惠
export const PRODUCT_YOUXUAN = 993 // 皇冠标识

export const PRODUCT_SCHEDULE = 994 // 档期管理
export const PRODUCT_QA = 995 // 社区问答
export const PRODUCT_DYNAMIC = 996 // 动态管理
export const PRODUCT_CASE = 997 // 案例管理
export const PRODUCT_MEAL = 998 // 套餐管理
